// extracted by mini-css-extract-plugin
export default {"Canchas":"canchas_Canchas__YpnvS","tituloCancha":"canchas_tituloCancha__6LFOC","titulo":"canchas_titulo__9mGZ3"};